import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";

import Token from "./utilities/jwt/Token";

const routes = [
  {
    path: "/",
    name: "app",
    component: App,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("./pages/main/Home.vue"),
      },
      {
        path: "/registros",
        name: "registros",
        component: () => import("./pages/registro/RegistrosView.vue"),
      },
      {
        path: "/unidades",
        name: "unidades",
        component: () => import("./pages/unidades/UnidadesView.vue"),
      },
      {
        path: "/setores",
        name: "setores",
        component: () => import("./pages/setores/SetoresView.vue"),
      },
      {
        path: "/tipos",
        name: "tipos",
        component: () => import("./pages/tipos/TipoView.vue"),
      },
      {
        path: "/users",
        name: "users",
        component: () => import("./pages/users/UsersView.vue"),
      },
      {
        path: "/groups",
        name: "groups",
        component: () => import("./pages/groups/GroupsView.vue"),

      },
      {
        path: "/log",
        name: "log",
        component: () => import("./pages/log/LogView.vue"),

      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    component: () => import("./pages/not_found/NotFound.vue"),
  },
  {
    path: "/access-denied",
    name: "access-denied",
    component: () => import("./pages/not_found/AccessDenied.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

//VERIFICA SE POSSUI LOCAL NO SESSION STORAGE, SE NÃO, DEVOLVE PARA A TELA DE NÃO AUTORIZADO
//DESCOMENTAR EM PRODUÇÃO
router.beforeEach((to, from, next) => {
  const local = new Token().getCookie('local');
  const token = new Token().getCookie('access_token');
  if (!token && !local && (to.name !== 'access-denied')) {
    next({ name: 'access-denied' });
  } else {
    next();
  }
});

export default router;

